module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0083.jpg?v=36798df4";